const projects = [
  {
    project:'Trybe Futebol Club',
    img:'tfc.png',
    description: 'It is a Rest API to manage the data of a football championship. Created using TypeScript, OOP and SOLID principes.',
    secBtnType: 'Demo',
    secLink: 'http://trybe-futebol-clube.surge.sh/',
    code: 'https://github.com/heitortessaro/trybe-futebol-clube',
    type: "Back-End",
  },
  {
    project:'Integrado ',
    img:'integrado.jpg',
    description: 'Provides a CRUD for managing universities informations from south american countries. It also implements a script to seed the database.',
    secBtnType: 'Docs Postman',
    secLink: 'https://documenter.getpostman.com/view/21397186/2s7ZEBnMex',
    code: 'https://github.com/heitortessaro/Integrado',
    type: "Back-End",
  }, 
  {
    project:'Proagro ',
    img:'proagro.jpg',
    description: 'Provides a page to register and access information related to the Agricultural Activity Assurance Program - Proagro.',
    secBtnType: 'Demo',
    secLink: 'http://proagro-facil-heitor.surge.sh/',
    code: 'https://github.com/heitortessaro/proagro-facil',
    type: "Full-Stack",
  }, 
  {
    project:'Trivia Game',
    img:'trivia.png',
    description: 'Online version of the popular game Trivia. It uses Redux, Hooks, Tailwind, DaisyUI, the Open Trivia Database.',
    secBtnType: 'Demo',
    secLink: 'https://trivia-game-p8t5vpu0f-heitortessaro.vercel.app/',
    code: 'https://github.com/heitortessaro/TriviaGame2/',
    type: "Front-End",
  },
  {
    project:'Trybe Wallet',
    img:'wallet.png',
    description: 'Provides a currency converter spending control wallet. It uses React, Redux, and Bootstrap.',
    secBtnType: 'Demo',
    secLink: 'https://trybewallet-ioqsphljg-heitortessaro.vercel.app/',
    code: 'https://github.com/heitortessaro/TrybeWallet',
    type: "Front-End",
  },
  {
    project:'Planet Search',
    img:'starwars.png',
    description: 'Provides filter list to find the Star Wars planets. It uses React, Context API, Hooks, and Bootstrap.',
    secBtnType: 'Demo',
    secLink: 'https://starwars-planets-search-rosy.vercel.app/',
    code: 'https://github.com/heitortessaro/starwars-planets-search',
    type: "Front-End",
  },
  {
    project:'Store Manager',
    img:'store.jpg',
    description: 'It is a Rest API that provides a sales management system in the dropshipping format.',
    secBtnType: 'Docs Postman',
    secLink: 'https://documenter.getpostman.com/view/21397186/UzJJtx5k',
    code: 'https://github.com/heitortessaro/store-manager',
    type: "Back-End",
  }, 
  {
    project:'Blogs API',
    img:'blogs.jpg',
    description: 'It is a Rest API that enables the management of users and posts for a blog application.',
    secBtnType: 'Docs Postman',
    secLink: 'https://documenter.getpostman.com/view/21397186/UzQyqP5N',
    code: 'https://github.com/heitortessaro/blogs-api',
    type: "Back-End",
  },  
  {
    project:'Car Shop',
    img:'carShop.jpg',
    description: 'It is a Rest API to manage the data of a car dealership. It uses TypeScript, MongoDB, TDD, OOP and SOLID principes.',
    code: 'https://github.com/heitortessaro/Car-Shoop',
    type: "Back-End",
  }      
];

export default projects;